<script lang="js" setup>
import {socialInfo, socialLinks} from "~/utils/social.js";

const {signInModal, signUpModal, navigateToOrSignIn} = useRedirectLogin()

const menu = [
  {
    titulo: 'Sobre Nós',
    links: [
      {descricao: 'Sobre Nós', link: '/sobre-nos'},
      {descricao: 'Entrar', fn: signInModal},
      {descricao: 'Cadastre-se', fn: signUpModal},
    ]
  },
  {
    titulo: 'Para Produtores',
    links: [
      {descricao: 'Criar Evento', fn: () => navigateToOrSignIn('/produtor/eventos/adicionar')},
      {descricao: 'Fale com um Consultor', link: socialLinks.WHATSAPP.link},
    ]
  },
  {
    titulo: 'Para Consumidores',
    links: [
      {descricao: 'Política de Privacidade', link: '/politicas/privacidade'},
      {descricao: 'Termos de Uso', link: '/politicas/termos-de-uso'},
      // {descricao: 'Meia Entrada', link: '/politicas/mei-entrada'},
    ]
  }
]

const socialIconLinks = Object.values(socialLinks)

const year = computed(() => new Date().getFullYear())
</script>
<template>
  <!-- Footer-->
  <footer class="footer bg-dark pt-5">
    <div class="container">
      <!-- Links-->
      <div class="row pb-md-3 pb-lg-4">
        <div class="col-12 mb-4">
          <div class="d-flex flex-sm-row flex-column justify-content-between mx-n2">
            <div class="mb-sm-0 mb-4 px-2">
              <nuxt-link class="d-inline-block mb-2" to="/">
                <img src="~/assets/img/logo/logo_white.png" width="55" alt="logo"/>
              </nuxt-link>
              <ul class="nav flex-column mb-sm-4 mb-2">
                <li class="nav-item mb-2">
                  <a class="nav-link-light p-0 fw-normal" :href="`mailto:${socialInfo.emails.commercial}`">
                    <i class="fi-mail mt-n1 me-2 align-middle opacity-70"></i>{{socialInfo.emails.commercial}}</a>
                </li>
                <li class="nav-item mb-2">
                  <a class="nav-link-light p-0 fw-normal" :href="`mailto:${socialInfo.emails.support}`">
                    <i class="fi-mail mt-n1 me-2 align-middle opacity-70"></i>{{socialInfo.emails.support}}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link-light p-0 fw-normal" :href="socialLinks.WHATSAPP.link">
                    <i class="fi-device-mobile mt-n1 me-2 align-middle opacity-70"></i>{{socialInfo.phones.whatsapp}}</a>
                </li>
              </ul>
            </div>
            <div v-for="(item, key) in menu" :key="key" class="mb-sm-0 mb-4 px-2">
              <h4 class="h5 text-light">{{ item.titulo }}</h4>
              <ul class="nav flex-column">
                <li v-for="(itn, k) in item.links" :key="k" class="nav-item mb-2">
                  <a v-if="itn.link" class="nav-link-light p-0 fw-normal" :href="itn.link">{{ itn.descricao }}</a>
                  <button v-else class="btn nav-link-light p-0 fw-normal" @click="itn.fn">{{ itn.descricao }}</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="py-4 border-top border-light">
          <div class="container d-flex flex-column flex-lg-row align-items-center justify-content-between py-2">
            <!-- Copyright-->
            <p class="order-lg-1 order-2 fs-sm mb-2 mb-lg-0">
              <a class="nav-link-light fw-bold" href="#!" rel="noopener">{{socialInfo.fantasyName}}</a> <span
                class="text-light opacity-60">&copy;&nbsp;{{ year }}</span>
            </p>
            <div class="d-flex flex-lg-row flex-column align-items-center order-lg-2 order-1 ms-lg-4 mb-lg-0 mb-4">
              <div class="d-flex align-items-center">
                <!-- Socials-->
                <div class="ms-4 ps-lg-2 text-nowrap">
                  <a v-for="(itn, i) in socialIconLinks" :key="i"
                     class="btn btn-icon btn-translucent-light btn-xs rounded-circle ms-2" :href="itn.link">
                    <Icon :icon="itn.icon" style="font-size: 20px"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
